<template>
    <div class="flow-node rounded-lg shadow-lg border-2 min-w-[180px]"
        :style="{ borderColor: color, background: 'var(--ui-bg)' }">
        <!-- header -->
        <div class="flex items-center gap-2 px-3 py-1.5 rounded-t-md text-white text-xs font-semibold select-none"
            :style="{ backgroundColor: color }">
            <span>{{ icon }}</span>
            <span>{{ title }}</span>
        </div>
        <!-- body: nodrag stops Vue Flow capturing pointer-down on form controls -->
        <div class="nodrag nowheel px-3 py-2 space-y-1.5 text-xs text-gray-200">
            <slot />
        </div>
    </div>
</template>

<script setup>
defineProps({
    title: String,
    icon: { type: String, default: '◉' },
    color: { type: String, default: '#475569' },
});
</script>

<style>
.flow-node { font-size: 11px; }
.flow-node select,
.flow-node input {
    background: var(--ui-bg-input);
    color: #e2e8f0;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 4px;
    padding: 2px 4px;
    width: 100%;
    font-size: 11px;
}
.flow-node select:focus,
.flow-node input:focus {
    outline: none;
    border-color: var(--ui-active);
}
.flow-node label {
    color: #94a3b8;
    font-size: 10px;
}
.flow-node input.color-swatch {
    width: 28px;
    height: 28px;
    padding: 2px;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 4px;
    background: var(--ui-bg-input);
    cursor: pointer;
    flex-shrink: 0;
}
</style>
